import React from 'react';

import range from 'lodash/range';

class Pagination extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      pageCount: 1,
      currentPage: this.props.currentPage || 1
    };
  }

  componentWillMount () {
    this.updatePageCount(this.props.total, this.props.limitPerPage);
  }

  componentWillReceiveProps (nextProps) {
    this.updatePageCount(nextProps.total, nextProps.limitPerPage);

    if (nextProps.currentPage && nextProps.currentPage !== this.state.currentPage) {
      this.setState({currentPage: nextProps.currentPage});
    }
  }

  updatePageCount (total, limit) {
    let pageCount = Math.ceil(total / limit);
    this.setState({pageCount});
  }

  onNewPage (e, page) {
    e.preventDefault();

    this.setState({currentPage: page});

    this.props.onNewPage(page);
  }

  renderFirstPageItem () {
    if (this.state.currentPage === 1) {
      return (
        <li className='disabled'>
          <span ariaHidden="true">&laquo;</span>
        </li>
      )
    }
    else {
      return (
        <li key={0}>
          <a href="#" ariaLabel="Previous" onClick={(e) => this.onNewPage(e, 1)}>
            <span ariaHidden="true">&laquo;</span>
          </a>
        </li>
      )
    }
  }

  renderLastPageItem () {
    if (this.state.currentPage === this.state.pageCount) {
      return (
        <li key={this.state.pageCount} className='disabled'>
          <a href="#" ariaLabel="Next" onClick={(e) => this.onNewPage(e, this.state.pageCount)}>
            <span ariaHidden="true">&raquo;</span>
          </a>
        </li>
      )
    }
    else {
      return (
        <li key={this.state.pageCount + 1}>
          <a href="#" ariaLabel="Next" onClick={(e) => this.onNewPage(e, this.state.pageCount)}>
            <span ariaHidden="true">&raquo;</span>
          </a>
        </li>
      )
    }
  }

  renderPaginationItem (page) {
    if (this.state.currentPage === page) {
      return (
        <li className='active'>
          <span ariaHidden="true">{page}</span>
        </li>
      )
    }
    else {
      return (
        <li key={page}>
          <a href="#" ariaLabel="Previous" onClick={(e) => this.onNewPage(e, page)}>
            <span ariaHidden="true">{page}</span>
          </a>
        </li>
      )
    }
  }

  render () {
    return (
      <ul className='pagination' style={this.props.style}>
        {this.renderFirstPageItem()}
        {
          range(1, this.state.pageCount + 1)
          .map((page) => this.renderPaginationItem(page))
        }
        {this.renderLastPageItem()}
      </ul>
    )
  }
}

Pagination.defaultProps = {
  total: 0,
  limitPerPage: 1,
  onNewPage: () => {}
}

export default Pagination;



/** WEBPACK FOOTER **
 ** ./modules/shared/crud_pagination.js
 **/